import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedHTMLMessage } from "react-intl";

class CorporateTarrif extends Component {
  render() {
    return (
      <div className="container my-5">
        {/* Page Title */}
        <h1 className="mb-4 text-center">
          <FormattedHTMLMessage id="aboutus.title" defaultMessage="Corporate Tariff Plans" />
        </h1>

        {/* Description */}
        <div className="mb-4 text-center">
          <FormattedHTMLMessage
            id="aboutus.desc_1"
            defaultMessage="<p class='text-muted'>Choose the best corporate plan for your organization.</p>"
          />
        </div>

        {/* Tariff Table */}
        <div className="table-responsive">
          <table className="table table-bordered table-striped text-center">
            <thead className="table-dark">
              <tr>
                <th>Plan</th>
                <th>Features</th>
                <th>Price (per month)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Basic</td>
                <td>Access to standard tools, Email support</td>
                <td>$99</td>
              </tr>
              <tr>
                <td>Professional</td>
                <td>Everything in Basic + HR analytics, Priority support</td>
                <td>$199</td>
              </tr>
              <tr>
                <td>Enterprise</td>
                <td>All features + Dedicated account manager, Custom solutions</td>
                <td>$499</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Extra Note */}
        <div className="mt-4 text-center">
          <FormattedHTMLMessage
            id="aboutus.title_4"
            defaultMessage="<p class='text-muted'>Contact us for custom corporate pricing tailored to your needs.</p>"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.locale.lang
  };
};

export default connect(mapStateToProps, {})(CorporateTarrif);
